<template>
  <div class="home">
    <div class="logo-container">
      <img alt="Vue logo" src="../assets/logo.png" class="adaptive-image">
      <HelloWorld msg="Welcome"/>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  components: {
    HelloWorld
  }
}
</script>

<style scoped>
.adaptive-image {
  max-width: 90%; /* Ensure the image doesn't exceed its original width */
  height: auto; /* Automatically adjust the height while maintaining aspect ratio */
}

.logo-container {
  text-align: center; /* Center the content horizontally */
  margin-top: 20px; /* Adjust the top margin as needed */
}

/* You can further adjust the spacing between the logo and "Welcome" here */
</style>
